import React, { useState } from 'react'
import { signInWithRedirect } from 'aws-amplify/auth'

interface LoginProps {
  onSuccess: () => void
}

export const Login: React.FC<LoginProps> = ({ onSuccess: _onSuccess }) => {
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleMicrosoftSignIn = async () => {
    setError('')
    setIsLoading(true)
    try {
      await signInWithRedirect({ provider: { custom: 'EntraID' } })
    } catch (err: any) {
      console.error('Error signing in with Microsoft:', err)
      setError('Failed to sign in with Microsoft. Please try again.')
      setIsLoading(false)
    }
  }

  return (
    <div className="w-full max-w-md mx-auto animate-[fadeIn_0.5s_ease-out]">
      <div className="glass-effect rounded-xl shadow-xl p-8 border border-indigo-300/30 backdrop-blur-md">
        <div className="flex flex-col items-center mb-6">
          <img 
            src="/images/ed-character-logo.png" 
            alt="Ask Ed Logo" 
            className="h-32 drop-shadow-lg animate-[float_3s_ease-in-out_infinite]" 
          />
          <h2 className="text-3xl font-bold mt-4 mb-2 text-center text-white drop-shadow-md">
            Ask Ed
          </h2>
          <div className="w-24 h-1 bg-indigo-400 rounded-full mb-4"></div>
          <p className="text-white/80 text-center italic">
            "Your virtual colleague, ready to assist Evolution Design Inc. team members."
          </p>
        </div>
        
        {error && (
          <div className="bg-destructive/20 text-white border border-destructive/30 p-4 rounded-lg mb-6 backdrop-blur-sm animate-[fadeIn_0.3s_ease-out]">
            <p className="text-sm font-medium">{error}</p>
          </div>
        )}

        <button
          onClick={handleMicrosoftSignIn}
          disabled={isLoading}
          className="w-full bg-white hover:bg-gray-50 text-gray-800 py-3 px-4 rounded-lg font-medium shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-3"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 23 23">
            <path fill="#f35325" d="M1 1h10v10H1z"/>
            <path fill="#81bc06" d="M12 1h10v10H12z"/>
            <path fill="#05a6f0" d="M1 12h10v10H1z"/>
            <path fill="#ffba08" d="M12 12h10v10H12z"/>
          </svg>
          {isLoading ? 'Redirecting...' : 'ED SSO Login'}
        </button>
      </div>
    </div>
  )
}
